import React from 'react';
import { Container, Row, Col, Link } from '@paypalcorp/pp-react';
import { triggerHelpCenter } from '../../common/domUtils';
import { parseMessages } from '../../utilityHelper';
import { get } from 'lodash';
import MinimalHeader from './MinimalHeader';
import MerchantHeader from './MerchantHeader';
const propertyInfo = parseMessages('common/header-ppgf');

const GivingHeader = ({ directModel, selectedTab, confirmationFlow, merchantHeader }) => {

    const triggerHelp = () => {
        triggerHelpCenter();
    }

    return (
        <>
            {merchantHeader ? <MerchantHeader /> :
                <Container fluid={true} style={{ background: '#142C8E', minHeight: '60px' }}>
                    {confirmationFlow ? <MinimalHeader /> :
                        <Row style={{ maxWidth: '1192px', margin: 'auto', padding: '15px 0px' }}>
                            <Col xs={9}>
                                <Link href="/">
                                    <img src='https://www.paypalobjects.com/paypal-ui/logos/svg/paypal-wordmark-monotone.svg' alt={get(propertyInfo, 'header.logo')} width='120' />
                                </Link>
                            </Col>
                            <Col style={{ marginTop: '10px', textAlign: 'right' }}>
                                {selectedTab == 'ppgfPanel' && !directModel &&
                                    <Link className="help" data-fpti="help" inverse size='sm' style={{ marginRight: '20px' }} onClick={triggerHelp}>{get(propertyInfo, 'header.help')}</Link>
                                }
                                <Link href='/givingfund/logout' data-fpti="logoutLink" inverse size='sm'>
                                    {get(propertyInfo, 'header.logout')}
                                </Link>
                            </Col>
                        </Row>
                    }
                </Container>
            }
        </>
    )
}
export default GivingHeader;